import { rem } from 'polished'
import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import Divider from './Divider'
import SummaryDataItem from './SummaryDataItem'

import FormatCurrency from 'components/Common/FormatCurrency'

type Props = {
  isBooked: boolean
  confirmationTitle?: string
  confirmationCode?: string
  priceTitle?: string
  price?: number
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`

const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(12)};
`

function ConfirmationDetails({
  isBooked,
  confirmationTitle,
  confirmationCode,
  priceTitle,
  price,
}: Props) {
  const intl = useIntl()
  const defaultConfirmationTitle = intl.formatMessage({
    id: 'zr0qDuz14Q',
    defaultMessage: 'Confirmation number',
    description: 'Default label for booking confirmation number in trip item summary',
  })
  const totalPaidTitle = intl.formatMessage({
    id: 'nPW5KeatLj',
    defaultMessage: 'Total paid',
    description: 'Label for total amount paid on a booked trip item',
  })
  const priceLabel = intl.formatMessage({
    id: 'jf8pVL5+kA',
    defaultMessage: 'Price',
    description: 'Label for price of an unbooked trip item',
  })
  const resolvedConfirmationTitle = confirmationTitle ?? defaultConfirmationTitle
  const resolvedPriceTitle = priceTitle ?? (isBooked ? totalPaidTitle : priceLabel)
  if (!confirmationCode && !price) return null
  return (
    <>
      <Divider />
      <Wrapper>
        <LeftContent>
          <SummaryDataItem title={resolvedConfirmationTitle} value={confirmationCode} />
          {price && (
            <SummaryDataItem
              title={resolvedPriceTitle}
              value={<FormatCurrency value={price} />}
            />
          )}
        </LeftContent>
      </Wrapper>
    </>
  )
}

export default ConfirmationDetails
